define([
	"dojo/_base/declare",
	"csi/xml",
	"./MaterialMassAction"
], function(declare,xml,MaterialMassAction) {

	function _canAggregatePM(/*Context*/ctx, /*FormData*/fd) {
			// summary: only allow selection of nodes with Write access
			return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_ADMIN);
	};

	return declare(MaterialMassAction, {
		getFormData: function() {
			// summary: make sure that at least one part material is selected and require admin rights on the part materials
			var	fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = _canAggregatePM;
			return fd;
		}
	});
});